export default __webpack_public_path__ + "static/media/gallery_03.a4c4786b.jpg";